import { render, staticRenderFns } from "./diamond.vue?vue&type=template&id=42fb13af&scoped=true&"
import script from "./diamond.vue?vue&type=script&lang=js&"
export * from "./diamond.vue?vue&type=script&lang=js&"
import style0 from "./diamond.vue?vue&type=style&index=0&id=42fb13af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb13af",
  null
  
)

export default component.exports